import React from "react";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
  },
  userText: {
    textAlign: "left",
    marginLeft: "1.562rem",
  },
}));

const UserCard = ({ avatar, person, job }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Avatar aria-label="person">{avatar}</Avatar>
      <div className={classes.userText}>
        <Typography variant="subtitle1" color="primary">
          {person}
        </Typography>
        <Typography variant="subtitle2" color="secondary">
          {job}
        </Typography>
      </div>
    </div>
  );
};

export default UserCard;
